// extracted by mini-css-extract-plugin
export default {"container":"RisingText_container__7cO+h","layer":"RisingText_layer__9SavS"};